// Collection filtering and load more functionality
export function initCollection() {
  const collectionList = document.querySelector('.collection__list')
  const loadMoreButton = document.querySelector('.collection__load-more-btn')

  if (!collectionList) return

  // Initialize collection item overlay
  // initCollectionOverlay(); // Disabled - items now link directly to pages

  // Get the current page URL for AJAX requests
  const currentPath = window.location.pathname

  // Hero section: Category hover/click functionality
  const heroLinks = document.querySelectorAll('.collection__hero-link')
  const heroItems = document.querySelectorAll('.collection__hero-item')

  heroLinks.forEach((link) => {
    // Hover to preview image + title
    link.addEventListener('mouseenter', function () {
      const category = this.getAttribute('data-category')

      // Remove active state from all
      heroLinks.forEach((l) =>
        l.classList.remove('collection__hero-link--active')
      )
      heroItems.forEach((item) =>
        item.classList.remove('collection__hero-item--active')
      )

      // Add active state to hovered
      this.classList.add('collection__hero-link--active')
      const matchingItem = document.querySelector(
        `.collection__hero-item[data-category="${category}"]`
      )
      if (matchingItem) {
        matchingItem.classList.add('collection__hero-item--active')
      }
    })

    // Links now navigate directly to collection-category pages
    // No click handler needed - removed scroll-to-filters behavior
  })

  // Initialize filters - use event capturing to intercept before Swup
  // document.querySelectorAll('.collection__filter-link').forEach(link => {
  //   link.addEventListener('click', async function(e) {
  //     // Skip if disabled
  //     if (this.classList.contains('collection__filter-link--disabled')) {
  //       e.preventDefault();
  //       return;
  //     }

  //     e.preventDefault();
  //     e.stopPropagation();

  //     let currentTag = collectionList.getAttribute('data-tag') || '';
  //     let currentCategory = collectionList.getAttribute('data-category') || '';

  //     // Update the appropriate filter based on what was clicked
  //     if (this.dataset.tag !== undefined) {
  //       // Tag filter clicked - clear category
  //       currentTag = this.dataset.tag || '';
  //       currentCategory = '';
  //     } else if (this.dataset.category !== undefined) {
  //       // Category filter clicked - clear tag
  //       currentCategory = this.dataset.category || '';
  //       currentTag = '';
  //     } else {
  //       // "All" link clicked - clear all filters
  //       currentTag = '';
  //       currentCategory = '';
  //     }

  //     // Build new URL with both filters
  //     const params = new URLSearchParams();
  //     if (currentTag) params.set('tag', currentTag);
  //     if (currentCategory) params.set('category', currentCategory);

  //     const newUrl = currentPath + (params.toString() ? '?' + params.toString() : '');

  //     // Update URL without page reload
  //     history.pushState({}, '', newUrl);

  //     // Load filtered content
  //     await loadFilteredContent(currentTag, currentCategory);
  //   }, true); // Use capture phase to intercept before Swup
  // });

  // Load more functionality
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', async function () {
      const page = parseInt(collectionList.getAttribute('data-page')) || 2
      const tag = collectionList.getAttribute('data-tag') || ''
      const category = collectionList.getAttribute('data-category') || ''

      this.textContent = 'Loading...'
      this.disabled = true

      let url = `${currentPath}.json?page=${page}`

      if (tag) url += `&tag=${tag}`
      if (category) url += `&category=${category}`

      try {
        const response = await fetch(url)
        const data = await response.json()

        if (data.html) {
          collectionList.insertAdjacentHTML('beforeend', data.html)
          collectionList.setAttribute('data-page', (page + 1).toString())

          // Animate newly loaded items
          const allItems = collectionList.querySelectorAll('.f-up')
          const newItems = Array.from(allItems).slice(
            -(data.html.match(/class="[^"]*f-up[^"]*"/g) || []).length
          )

          newItems.forEach((item) => {
            item.style.opacity = '0'
            item.style.transform = 'translateY(20px)'
          })

          import('gsap').then(({ default: gsap }) => {
            gsap.to(newItems, {
              opacity: 1,
              y: 0,
              stagger: 0.1,
              duration: 0.6,
              ease: 'power2.out',
            })
          })
        }

        if (data.more) {
          this.textContent = 'Load More'
          this.disabled = false
        } else {
          this.parentElement.style.display = 'none'
        }
      } catch (error) {
        this.textContent = 'Try Again'
        this.disabled = false
      }
    })
  }

  // Handle browser back/forward buttons
  window.addEventListener('popstate', function () {
    const urlParams = new URLSearchParams(window.location.search)
    const tag = urlParams.get('tag') || ''
    const category = urlParams.get('category') || ''

    loadFilteredContent(tag, category)
  })

  async function loadFilteredContent(tag, category) {
    // Fade out existing items
    collectionList.style.opacity = '0'

    let url = `${currentPath}.json`
    const params = new URLSearchParams()

    if (tag) params.set('tag', tag)
    if (category) params.set('category', category)

    if (params.toString()) {
      url += '?' + params.toString()
    }

    try {
      const response = await fetch(url)
      const data = await response.json()

      // Update content
      collectionList.innerHTML = data.html

      // Reset GSAP properties on new items and animate them in
      const newItems = collectionList.querySelectorAll('.f-up')
      newItems.forEach((item) => {
        // Set initial state
        item.style.opacity = '0'
        item.style.transform = 'translateY(20px)'
      })

      // Animate items in with stagger
      import('gsap').then(({ default: gsap }) => {
        gsap.to(newItems, {
          opacity: 1,
          y: 0,
          stagger: 0.1,
          duration: 0.6,
          ease: 'power2.out',
        })
      })

      // Fade items back in
      collectionList.style.opacity = '1'

      // Update data attributes
      collectionList.setAttribute('data-tag', tag)
      collectionList.setAttribute('data-category', category)
      collectionList.setAttribute('data-page', '2')

      // Update load more button
      const loadMoreContainer = document.querySelector('.collection__load-more')
      if (loadMoreContainer) {
        loadMoreContainer.style.display = data.more ? 'block' : 'none'
      }

      // Update filter active states
      // updateFilterStates(tag, category);

      // Update tag disabled states
      updateTagStates(data.tags || [])
    } catch (error) {
      collectionList.style.opacity = '1'
    }
  }

  // function updateFilterStates(activeTag, activeCategory) {
  //   // Remove all active states
  //   document.querySelectorAll('.collection__filter-link').forEach(link => {
  //     link.classList.remove('collection__filter-link--active');
  //   });

  //   // Add active state to both tag and category if present
  //   if (activeTag) {
  //     const activeTagLink = document.querySelector(`[data-tag="${activeTag}"]`);
  //     if (activeTagLink) activeTagLink.classList.add('collection__filter-link--active');
  //   }

  //   if (activeCategory) {
  //     const activeCategoryLink = document.querySelector(`[data-category="${activeCategory}"]`);
  //     if (activeCategoryLink) activeCategoryLink.classList.add('collection__filter-link--active');
  //   }

  //   // Show "All" as active only if no filters are selected
  //   if (!activeTag && !activeCategory) {
  //     const allLink = document.querySelector('.collection__filter-link--all');
  //     if (allLink) allLink.classList.add('collection__filter-link--active');
  //   }
  // }

  // function updateTagStates(tags) {
  //   // First, find all tag links by looking for elements containing the tag text
  //   const allTagLinks = document.querySelectorAll('.collection__filter-link--tag');

  //   tags.forEach(tag => {
  //     // Find the tag link by matching the text content
  //     let tagLink = null;
  //     allTagLinks.forEach(link => {
  //       if (link.textContent.trim() === tag.text) {
  //         tagLink = link;
  //       }
  //     });

  //     if (tagLink) {
  //       // Update disabled state
  //       if (tag.disabled) {
  //         tagLink.classList.add('collection__filter-link--disabled');
  //         tagLink.href = '#';
  //         tagLink.removeAttribute('data-swup-ignore');
  //         tagLink.removeAttribute('data-tag');
  //       } else {
  //         tagLink.classList.remove('collection__filter-link--disabled');
  //         tagLink.href = `${currentPath}?tag=${tag.slug}`;
  //         tagLink.setAttribute('data-swup-ignore', '');
  //         tagLink.setAttribute('data-tag', tag.slug);
  //       }
  //     }
  //   });
  // }
}

// ==========================================================================
// Collection Item Overlay Functions
// ==========================================================================

function openCollectionOverlay(itemUrl) {
  const overlay = document.querySelector('.overlay')
  const overlayContent = document.querySelector('.overlay__content')

  if (!overlay || !overlayContent) return

  // Show loading state
  overlayContent.innerHTML = '<div class="overlay__loading">Loading...</div>'
  overlay.classList.add('overlay--active')

  // Prevent body scroll and preserve scroll position
  const scrollY = window.scrollY
  document.body.style.top = `-${scrollY}px`
  document.body.classList.add('body--fixed')

  // Fetch collection item data
  fetch(`${itemUrl}?overlay=true`)
    .then((response) => response.json())
    .then((itemData) => {
      // Create close button
      const closeButton = document.createElement('button')
      closeButton.className = 'overlay__close'
      closeButton.innerHTML = ''
      closeButton.setAttribute('aria-label', 'Close overlay')

      // Create navigation arrows
      const navHtml = `
        <div class="overlay__navigation">
          ${itemData.prevUrl ? `<button class="overlay__nav overlay__nav--prev" data-url="${itemData.prevUrl}" aria-label="Previous item"></button>` : '<div></div>'}
          ${itemData.nextUrl ? `<button class="overlay__nav overlay__nav--next" data-url="${itemData.nextUrl}" aria-label="Next item"></button>` : '<div></div>'}
        </div>
      `

      // Create overlay content with proper BEM structure
      const overlayBody = document.createElement('div')

      overlayBody.innerHTML = `
        ${itemData.imageUrl ? `<div class="overlay__image"><img src="${itemData.imageUrl}" alt="${itemData.imageAlt}" /></div>` : ''}
        <div class="overlay__inner">
          ${
            itemData.tags && itemData.tags.length
              ? `
            <ul class="overlay__tags">
              ${itemData.tags.map((tag) => `<li>${tag}</li>`).join('')}
            </ul>
          `
              : ''
          }
          <h2 class="overlay__title">${itemData.title}</h2>
          
          ${
            itemData.metadata && itemData.metadata.length
              ? `
            <div class="overlay__meta">
              ${itemData.metadata.map((meta) => `<div class="overlay__meta-item">${meta.label}: ${meta.value}</div>`).join('')}
            </div>
          `
              : ''
          }
          ${itemData.description ? `<div class="overlay__body">${itemData.description}</div>` : ''}
          
          ${
            itemData.pdfFiles && itemData.pdfFiles.length
              ? `
            <div class="overlay__section">
              <h4>Files</h4>
              ${itemData.pdfFiles.map((file) => `<p><a href="${file.url}" target="_blank" rel="noopener">${file.filename}</a></p>`).join('')}
            </div>
          `
              : ''
          }
        </div>
      `

      // Clear loading and add content
      overlayContent.innerHTML = ''
      overlayContent.appendChild(closeButton)
      overlayContent.appendChild(overlayBody)

      // Add close functionality
      closeButton.addEventListener('click', closeCollectionOverlay)

      // Add navigation functionality
      const prevBtn = overlayContent.querySelector('.overlay__nav--prev')
      const nextBtn = overlayContent.querySelector('.overlay__nav--next')

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          openCollectionOverlay(this.getAttribute('data-url'))
        })
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          openCollectionOverlay(this.getAttribute('data-url'))
        })
      }

      // Close on click anywhere outside overlay content
      const handleClickOutside = (e) => {
        if (
          overlay.classList.contains('overlay--active') &&
          !overlayContent.contains(e.target)
        ) {
          closeCollectionOverlay()
        }
      }
      document.addEventListener('click', handleClickOutside)

      // Close on Escape key
      const handleEscape = (e) => {
        if (
          e.key === 'Escape' &&
          overlay.classList.contains('overlay--active')
        ) {
          closeCollectionOverlay()
        }
      }
      document.addEventListener('keydown', handleEscape)

      // Store references for cleanup
      overlay._handleClickOutside = handleClickOutside
      overlay._handleEscape = handleEscape
    })
    .catch((error) => {
      overlayContent.innerHTML =
        '<div class="overlay__error">Error loading item details.</div>'
    })
}

function closeCollectionOverlay() {
  const overlay = document.querySelector('.overlay')
  const overlayContent = document.querySelector('.overlay__content')

  if (!overlay) return

  // Hide overlay
  overlay.classList.remove('overlay--active')

  // Clear content after animation
  setTimeout(() => {
    if (overlayContent) {
      overlayContent.innerHTML = ''
    }
  }, 300) // Match CSS transition duration

  // Clean up event listeners
  if (overlay._handleEscape) {
    document.removeEventListener('keydown', overlay._handleEscape)
    overlay._handleEscape = null
  }
  if (overlay._handleClickOutside) {
    document.removeEventListener('click', overlay._handleClickOutside)
    overlay._handleClickOutside = null
  }

  // Restore body scroll and position
  document.body.classList.remove('body--fixed')
  const scrollY = document.body.style.top
  document.body.style.top = ''
  window.scrollTo(0, parseInt(scrollY || '0') * -1)
}

// Initialize overlay functionality
function initCollectionOverlay() {
  // Use event delegation for collection list items
  const collectionList = document.querySelector('.collection__list')
  if (collectionList) {
    collectionList.addEventListener('click', function (e) {
      const button = e.target.closest('.collection-item__button')
      if (button) {
        e.preventDefault()
        e.stopPropagation()
        const listItem = button.closest('.collection-item')
        const itemUrl = listItem.getAttribute('data-item-url')
        if (itemUrl) {
          openCollectionOverlay(itemUrl)
        }
      }
    })
  }

  // Use event delegation for carousel items (anywhere on page)
  document.addEventListener('click', function (e) {
    const carouselButton = e.target.closest('.carousel-item__button')
    if (carouselButton) {
      e.preventDefault()
      e.stopPropagation()
      const itemUrl = carouselButton.getAttribute('data-item-url')
      if (itemUrl) {
        openCollectionOverlay(itemUrl)
      }
    }
  })
}
